var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"handouts-list"},_vm._l((_vm.files),function(file){return _c('li',{key:file.href},[_c('handout',{attrs:{"file":file}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }